import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const ShowSeansOnMap: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('booking');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('setting.show_seans_on_map.label')}
        description={t('setting.show_seans_on_map.subtitle')}
        value={settings.showSeans}
        onChange={(value: boolean) =>
          setSetting({
            alias: ESettingsAliases.SHOW_SEANS_ON_MAP,
            value: value ? '1' : '0',
          })
        }
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
        disabled={!isAvailable}
        variant="secondary"
        emptyBg
      />
    </>
  );
};
